import React, { useEffect } from 'react';
import { Row, Col, Card, Table, Tag } from 'antd';
import {
  UserOutlined,
  TeamOutlined,
  ShoppingCartOutlined,
  EnvironmentOutlined
} from '@ant-design/icons';
import { useDashboard } from '../store/dashboardContext';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

const DashboardPage: React.FC = () => {
  const {
    totalCustomers,
    totalUsers,
    totalOrders,
    totalCities,
    latestCustomers,
    latestOrders,
    fetchSummary
  } = useDashboard();

  const { t } = useTranslation();

  useEffect(() => {
    fetchSummary();
  }, []);

  const orderColumns = [
    { title: t('customer_code'), dataIndex: 'customerCode' },
    { title: t('total_price'), dataIndex: 'totalPrice' },
    {
      title: t('status'),
      dataIndex: 'status',
      render: (status: string) => (
        <Tag color={status === 'paid' ? 'green' : 'orange'}>
          {status?.toUpperCase()}
        </Tag>
      )
    },
    {
      title: t('created_at'),
      dataIndex: 'createdAt',
      render: (createdAt: string) => dayjs(createdAt).format('YYYY-MM-DD hh:mm A')
    }
  ];

  const customerColumns = [
    { title: t('name'), dataIndex: 'name' },
    { title: t('phone1'), dataIndex: 'phone1' },
    { title: t('customer_code'), dataIndex: 'customerCode' },
    {
      title: t('city'),
      dataIndex: ['city', 'name_eng'],
      render: (_: any, record: any) => record.city?.name_eng || '-'
    },
    {
      title: t('created_at'),
      dataIndex: 'createdAt',
      render: (createdAt: string) => dayjs(createdAt).format('YYYY-MM-DD hh:mm A')
    }
  ];

  return (
    <div style={{ padding: '16px' }}>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={12} lg={6}>
          <Card style={{ backgroundColor: '#4f46e5', color: 'white' }} bordered={false}>
            <TeamOutlined style={{ fontSize: 24 }} />
            <h3>{t('customers')}</h3>
            <p style={{ fontSize: 20 }}>{totalCustomers}</p>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={12} lg={6}>
          <Card style={{ backgroundColor: '#f59e0b', color: 'white' }} bordered={false}>
            <ShoppingCartOutlined style={{ fontSize: 24 }} />
            <h3>{t('orders')}</h3>
            <p style={{ fontSize: 20 }}>{totalOrders}</p>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={12} lg={6}>
          <Card style={{ backgroundColor: '#10b981', color: 'white' }} bordered={false}>
            <UserOutlined style={{ fontSize: 24 }} />
            <h3>{t('users')}</h3>
            <p style={{ fontSize: 20 }}>{totalUsers}</p>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={12} lg={6}>
          <Card style={{ backgroundColor: '#ec4899', color: 'white' }} bordered={false}>
            <EnvironmentOutlined style={{ fontSize: 24 }} />
            <h3>{t('cities')}</h3>
            <p style={{ fontSize: 20 }}>{totalCities}</p>
          </Card>
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
        <Col xs={24} lg={12}>
          <Card title={t('latest_customers')}>
            <Table
              rowKey="id"
              columns={customerColumns}
              dataSource={latestCustomers}
              pagination={false}
              scroll={{ x: 'max-content' }}
            />
          </Card>
        </Col>
        <Col xs={24} lg={12}>
          <Card title={t('latest_orders')}>
            <Table
              rowKey="id"
              columns={orderColumns}
              dataSource={latestOrders}
              pagination={false}
              scroll={{ x: 'max-content' }}
            />
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default DashboardPage;
